import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialogTitle } from "@angular/material/dialog";
import { TranslatePipe } from "@ngx-translate/core";

type DialogVariant = "info" | "alert";

@Component({
	selector: "app-dialog-header",
	standalone: true,
	imports: [MatDialogTitle, TranslatePipe],
	templateUrl: "./dialog-header.component.html",
	styleUrl: "./dialog-header.component.scss",
})
export class DialogHeaderComponent {
	@Input() title!: string;
	@Input() variant: DialogVariant;

	@Output() closeClick = new EventEmitter<void>();

	close() {
		this.closeClick.emit();
	}

	get iconPath(): string {
		return `assets/icons/${this.variant === "alert" ? "alert-triangle" : "info"}-solid.svg`;
	}
}